import { InjectionToken } from '@angular/core';

/**
 * A single icon sprite: the MatIconRegistry namespace ('' for the default,
 * unnamespaced set) and its raw SVG markup.
 */
export interface SsrIconSet {
  namespace: string;
  svg: string;
}

/**
 * SSR-only. The Express server reads the icon sprites from disk and provides
 * them through this token so MatIconRegistry can register them as literals.
 * During server render relative HTTP URLs (base '/') don't resolve, so without
 * this every <mat-icon svgIcon="..."> throws "Unable to find icon". Absent in
 * the browser, where sprites are fetched over HTTP instead.
 */
export const SSR_ICON_SETS_TOKEN = new InjectionToken<SsrIconSet[]>(
  'SSR_ICON_SETS',
);

/**
 * Single source of truth for the icon sprites and their namespaces. Consumed
 * by IconsModule (browser HTTP registration) and by server.ts (server-side
 * disk read). '' is the default, unnamespaced set.
 */
export const ICON_SET_FILES: { namespace: string; file: string }[] = [
  { namespace: '', file: 'assets/icons/material-twotone.svg' },
  { namespace: 'mat_outline', file: 'assets/icons/material-outline.svg' },
  { namespace: 'mat_solid', file: 'assets/icons/material-solid.svg' },
  { namespace: 'feather', file: 'assets/icons/feather.svg' },
  {
    namespace: 'heroicons_outline',
    file: 'assets/icons/heroicons-outline.svg',
  },
  { namespace: 'heroicons_solid', file: 'assets/icons/heroicons-solid.svg' },
];
